import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-state-modal',
  imports: [],
  templateUrl: './error-state-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorStateModalComponent {
  // Writable signals used instead of input() because NgbModal sets values
  // imperatively via componentInstance — signal inputs are read-only.
  readonly title = signal('');
  readonly alertMessage = signal('');

  private readonly activeModal = inject(NgbActiveModal);

  closeModal(): void {
    this.activeModal.close();
  }
}
